// The pieces of a conversation with Lena: her bubble, the athlete's, and
// the typing indicator before Lena speaks. Dados gerais and every assessment's
// guide share them.

import type { ReactNode } from "react";

import { PyfLogo } from "./PyfLogo";
import { copy } from "../i18n/pt-PT";

const bubble = "max-w-[85%] px-4 py-3 text-body leading-[var(--lh-body)]";
const pyfShape = "self-start rounded-bubble-pyf border border-line-8 bg-white";

/** `enter` false inside a screen that already arrives with its own motion. */
export function PyfBubble({ children, enter = true }: { children: ReactNode; enter?: boolean }) {
  return (
    <p className={`${bubble} ${enter ? "bubble-enter" : ""} ${pyfShape}`}>
      {children}
    </p>
  );
}

export function UserBubble({ children }: { children: ReactNode }) {
  return <p className={`${bubble} bubble-enter self-end rounded-bubble-user bg-violet text-white`}>{children}</p>;
}

/** `enter` false when it appears with a screen that already arrives with its own motion. */
export function TypingBubble({ label, enter = true }: { label: string; enter?: boolean }) {
  return (
    <p role="status" aria-label={label} className={`${enter ? "bubble-enter" : ""} flex gap-1 px-4 py-4 ${pyfShape}`}>
      <span className="typing-dot size-1.5 rounded-pill bg-muted" />
      <span className="typing-dot typing-dot-2 size-1.5 rounded-pill bg-muted" />
      <span className="typing-dot typing-dot-3 size-1.5 rounded-pill bg-muted" />
    </p>
  );
}

/** Lena's avatar, the PYF logo, and her name: the title of a conversation. */
export function PyfTitle() {
  return (
    <div className="flex items-center gap-2">
      {/* The avatar is decoration: a screen reader says her name once, not "PYF Lena". */}
      <span aria-hidden="true" className="flex size-8 items-center justify-center rounded-pill bg-violet">
        <PyfLogo className="w-4 text-cream-deep" />
      </span>
      <span className="text-title-sm font-semibold">{copy.assistant.name}</span>
    </div>
  );
}
